var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeatmap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 81,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.918a1 1 0 011-1h43.685a1 1 0 011 1v8.593a1 1 0 01-1 1H1a1 1 0 01-1-1v-8.593zM0 24.174a1 1 0 011-1h43.685a1 1 0 011 1v8.593a1 1 0 01-1 1H1a1 1 0 01-1-1v-8.594zM0 35.43a1 1 0 011-1h43.685a1 1 0 011 1v9.255a1 1 0 01-1 1H1a1 1 0 01-1-1v-9.256z",
    fill: "#52B2CA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.347 12.918a1 1 0 011-1h46.995a1 1 0 011 1v8.593a1 1 0 01-1 1H47.347a1 1 0 01-1-1v-8.593zM46.347 24.174a1 1 0 011-1h46.995a1 1 0 011 1v8.593a1 1 0 01-1 1H47.347a1 1 0 01-1-1v-8.594zM46.347 35.43a1 1 0 011-1h46.995a1 1 0 011 1v9.255a1 1 0 01-1 1H47.347a1 1 0 01-1-1v-9.256zM96.005 12.918a1 1 0 011-1h35.078a1 1 0 011 1v8.593a1 1 0 01-1 1H97.005a1 1 0 01-1-1v-8.593zM96.005 24.174a1 1 0 011-1h35.078a1 1 0 011 1v8.593a1 1 0 01-1 1H97.005a1 1 0 01-1-1v-8.594zM96.005 35.43a1 1 0 011-1h35.078a1 1 0 011 1v9.255a1 1 0 01-1 1H97.005a1 1 0 01-1-1v-9.256z",
    fill: "#EEE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1a1 1 0 011-1h43.685a1 1 0 011 1v9.256a1 1 0 01-1 1H1a1 1 0 01-1-1V1z",
    fill: "#52B2CA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.347 1a1 1 0 011-1h46.995a1 1 0 011 1v9.256a1 1 0 01-1 1H47.347a1 1 0 01-1-1V1zM96.005 1a1 1 0 011-1H144a1 1 0 011 1v9.256a1 1 0 01-1 1H97.005a1 1 0 01-1-1V1zM0 12.918a1 1 0 011-1h43.685a1 1 0 011 1v8.593a1 1 0 01-1 1H1a1 1 0 01-1-1v-8.593z",
    fill: "#BBE7F2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 24.174a1 1 0 011-1h43.685a1 1 0 011 1v8.593a1 1 0 01-1 1H1a1 1 0 01-1-1v-8.594zM0 35.43a1 1 0 011-1h43.685a1 1 0 011 1v9.255a1 1 0 01-1 1H1a1 1 0 01-1-1v-9.256z",
    fill: "#4179A8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.348 12.918a1 1 0 011-1h46.995a1 1 0 011 1v8.593a1 1 0 01-1 1H47.348a1 1 0 01-1-1v-8.593z",
    fill: "#EEE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.348 24.174a1 1 0 011-1h46.995a1 1 0 011 1v8.593a1 1 0 01-1 1H47.348a1 1 0 01-1-1v-8.594z",
    fill: "#BBE7F2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M46.348 35.43a1 1 0 011-1h46.995a1 1 0 011 1v9.255a1 1 0 01-1 1H47.348a1 1 0 01-1-1v-9.256z",
    fill: "#4179A8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M96.005 12.918a1 1 0 011-1H144a1 1 0 011 1v8.593a1 1 0 01-1 1H97.005a1 1 0 01-1-1v-8.593z",
    fill: "#52B2CA"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M96.005 24.174a1 1 0 011-1H144a1 1 0 011 1v8.593a1 1 0 01-1 1H97.005a1 1 0 01-1-1v-8.594z",
    fill: "#BBE7F2"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M96.005 35.43a1 1 0 011-1H144a1 1 0 011 1v9.255a1 1 0 01-1 1H97.005a1 1 0 01-1-1v-9.256zM0 1a1 1 0 011-1h43.685a1 1 0 011 1v9.256a1 1 0 01-1 1H1a1 1 0 01-1-1V1z",
    fill: "#52B2CA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M46.348 1a1 1 0 011-1h46.995a1 1 0 011 1v9.256a1 1 0 01-1 1H47.348a1 1 0 01-1-1V1z",
    fill: "#EEE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M96.005 1a1 1 0 011-1H144a1 1 0 011 1v9.256a1 1 0 01-1 1H97.005a1 1 0 01-1-1V1z",
    fill: "#52B2CA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0 47.347a1 1 0 011-1h43.685a1 1 0 011 1v8.594a1 1 0 01-1 1H1a1 1 0 01-1-1v-8.594z",
    fill: "#4179A8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0 58.603a1 1 0 011-1h43.685a1 1 0 011 1v8.593a1 1 0 01-1 1H1a1 1 0 01-1-1v-8.593z",
    fill: "#52B2CA"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M0 69.858a1 1 0 011-1h43.685a1 1 0 011 1v9.256a1 1 0 01-1 1H1a1 1 0 01-1-1v-9.256zM46.348 47.347a1 1 0 011-1h46.995a1 1 0 011 1v8.594a1 1 0 01-1 1H47.348a1 1 0 01-1-1v-8.594zM46.348 58.603a1 1 0 011-1h46.995a1 1 0 011 1v8.593a1 1 0 01-1 1H47.348a1 1 0 01-1-1v-8.593z",
    fill: "#BBE7F2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M46.348 69.858a1 1 0 011-1h46.995a1 1 0 011 1v9.256a1 1 0 01-1 1H47.348a1 1 0 01-1-1v-9.256z",
    fill: "#52B2CA"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M96.005 47.347a1 1 0 011-1H144a1 1 0 011 1v8.594a1 1 0 01-1 1H97.005a1 1 0 01-1-1v-8.594z",
    fill: "#4179A8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M96.005 58.603a1 1 0 011-1H144a1 1 0 011 1v8.593a1 1 0 01-1 1H97.005a1 1 0 01-1-1v-8.593z",
    fill: "#52B2CA"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M96.005 69.858a1 1 0 011-1H144a1 1 0 011 1v9.256a1 1 0 01-1 1H97.005a1 1 0 01-1-1v-9.256z",
    fill: "#EEE"
  })));
}
export default SvgHeatmap;